module.exports = __webpack_public_path__ + "img/button2.3d6c831d.png";